import React, { useState } from 'react';
import { Button, Input, colors, spacing, typography } from '../../../design-system/index.js';

export const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const sectionStyles = {
    padding: `${spacing[16]} 0`,
    borderBottom: `1px solid ${colors.border.light}`,
  };

  const titleStyles = {
    fontSize: typography.fontSize['2xl'],
    fontWeight: typography.fontWeight.light,
    color: colors.text.primary,
    textAlign: 'center',
    marginBottom: spacing[4],
    margin: `0 0 ${spacing[4]} 0`,
  };

  const subtitleStyles = {
    fontSize: typography.fontSize.base,
    lineHeight: typography.lineHeight.loose,
    color: colors.text.secondary,
    textAlign: 'center',
    marginBottom: spacing[12],
    maxWidth: '600px',
    margin: `0 auto ${spacing[12]} auto`,
  };

  const contentStyles = {
    maxWidth: '800px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: spacing[12],
    alignItems: 'start',
  };

  const contactInfoStyles = {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing[6],
  };

  const infoItemStyles = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: spacing[4],
    padding: spacing[4],
    backgroundColor: colors.background.secondary,
    borderRadius: spacing.borderRadius.base,
    border: `1px solid ${colors.border.default}`,
    transition: 'all 0.3s ease',
  };

  const iconStyles = {
    width: '24px',
    height: '24px',
    backgroundColor: colors.text.primary,
    borderRadius: spacing.borderRadius.sm,
    flexShrink: 0,
    marginTop: '2px',
  };

  const infoContentStyles = {
    flex: 1,
  };

  const infoTitleStyles = {
    fontSize: typography.fontSize.base,
    fontWeight: typography.fontWeight.normal,
    color: colors.text.primary,
    marginBottom: spacing[1],
    margin: `0 0 ${spacing[1]} 0`,
  };

  const infoTextStyles = {
    fontSize: typography.fontSize.sm,
    color: colors.text.secondary,
    margin: 0,
  };

  const formStyles = {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing[4],
  };

  const formGroupStyles = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: spacing[4],
  };

  const textareaStyles = {
    width: '100%',
    minHeight: '120px',
    padding: spacing.component.inputPadding,
    fontSize: typography.fontSize.base,
    fontWeight: typography.fontWeight.light,
    fontFamily: typography.fontFamily.primary,
    backgroundColor: colors.background.secondary,
    color: colors.text.primary,
    border: `1px solid ${colors.border.default}`,
    borderRadius: spacing.borderRadius.base,
    outline: 'none',
    resize: 'vertical',
    transition: 'all 0.15s ease-in-out',
  };

  const buttonContainerStyles = {
    display: 'flex',
    gap: spacing[3],
    justifyContent: 'flex-end',
  };

  const responsiveStyles = `
    @media (max-width: 768px) {
      .contact-content {
        grid-template-columns: 1fr !important;
        gap: ${spacing[8]} !important;
      }
      .form-group {
        grid-template-columns: 1fr !important;
      }
    }
  `;

  const contactInfo = [
    {
      title: "邮箱联系",
      content: "hello@example.com",
      description: "工作日内 24 小时回复"
    },
    {
      title: "微信咨询", 
      content: "WeChat_ID_123",
      description: "添加好友请备注来意"
    },
    {
      title: "工作地点",
      content: "上海 · 浦东新区",
      description: "支持远程协作"
    }
  ];

  const handleInputChange = (field) => (e) => {
    setFormData(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('提交表单:', formData);
    // 这里处理表单提交逻辑
  };

  const handleInfoItemMouseEnter = (e) => {
    e.currentTarget.style.backgroundColor = colors.background.tertiary;
    e.currentTarget.style.transform = 'translateX(5px)';
  };

  const handleInfoItemMouseLeave = (e) => {
    e.currentTarget.style.backgroundColor = colors.background.secondary;
    e.currentTarget.style.transform = 'translateX(0)';
  };

  const handleTextareaFocus = (e) => {
    e.target.style.borderColor = colors.text.primary;
    e.target.style.boxShadow = `0 0 0 2px ${colors.alpha.light12}`;
  };

  const handleTextareaBlur = (e) => {
    e.target.style.borderColor = colors.border.default;
    e.target.style.boxShadow = 'none';
  };

  return (
    <section style={sectionStyles} className="contact-section">
      <h2 style={titleStyles}>联系我</h2>
      <p style={subtitleStyles}>
        有项目合作意向或技术交流需求？欢迎通过以下方式联系我，
        让我们一起创造有价值的产品。
      </p>
      
      <div style={contentStyles} className="contact-content">
        {/* 联系信息 */}
        <div style={contactInfoStyles}>
          {contactInfo.map((info, index) => (
            <div
              key={index}
              style={infoItemStyles}
              onMouseEnter={handleInfoItemMouseEnter}
              onMouseLeave={handleInfoItemMouseLeave}
            >
              <div style={iconStyles} />
              <div style={infoContentStyles}>
                <h3 style={infoTitleStyles}>{info.title}</h3>
                <p style={infoTextStyles}>{info.content}</p>
                <p style={{...infoTextStyles, fontSize: typography.fontSize.xs, marginTop: spacing[1]}}>
                  {info.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* 联系表单 */}
        <form style={formStyles} className="contact-form" onSubmit={handleSubmit}>
          <div style={formGroupStyles} className="form-group">
            <Input
              label="姓名"
              placeholder="请输入您的姓名"
              value={formData.name}
              onChange={handleInputChange('name')}
            />
            <Input
              label="邮箱"
              type="email"
              placeholder="your@email.com"
              value={formData.email}
              onChange={handleInputChange('email')}
            />
          </div>
          
          <Input
            label="主题"
            placeholder="请简述您的需求"
            value={formData.subject}
            onChange={handleInputChange('subject')}
          />
          
          <div>
            <label style={{
              display: 'block',
              marginBottom: spacing[2],
              fontSize: typography.fontSize.sm,
              fontWeight: typography.fontWeight.normal,
              color: colors.text.primary,
              fontFamily: typography.fontFamily.primary,
            }}>
              详细信息
            </label>
            <textarea
              style={textareaStyles}
              placeholder="请详细描述您的项目需求、合作方式、时间计划等..."
              value={formData.message}
              onChange={handleInputChange('message')}
              onFocus={handleTextareaFocus}
              onBlur={handleTextareaBlur}
            />
          </div>
          
          <div style={buttonContainerStyles}>
            <Button variant="outline" type="button">
              保存草稿
            </Button>
            <Button variant="primary" type="submit">
              发送消息
            </Button>
          </div>
        </form>
      </div>

      <style>{responsiveStyles}</style>
    </section>
  );
};
